<template>
<div>
    <section>
        <b-field position="is-right">
            <b-input placeholder="Search..." type="search" icon="search" v-model="search">
            </b-input>
            <p class="control">
                <b-dropdown class="hover-rotate-90" hoverable aria-role="list" position="is-bottom-left" :disabled="toggleDelete">
                    <button class="button is-primary" slot="trigger">
                        <b-icon icon="plus" pack="fal"></b-icon>
                    </button>

                    <b-dropdown-item v-for="type in workshopTypes" aria-role="listitem" @click="addWorkshop({name:type.default,type:type.name},true)">
                        <b-icon :icon="icon(type.name)" pack="fad"></b-icon> {{type.title}}
                    </b-dropdown-item>
                </b-dropdown>
            </p>
            <p class="control">
                <button class="button is-danger" @click="toggleDelete = !toggleDelete">
                    <b-icon icon="minus" pack="fal"></b-icon>
                </button>
            </p>
        </b-field>

    </section>
    <section>
        <Draggable :list="$root.event.workshops" group="workshops" :options="{handle:'.draggy'}">
            <div class="arrangement-cards">
                <div class="card is-grid" v-for="event in filtered" :class="{ giggly: toggleDelete }">
                    <header class="card-header">
                        <p class="card-header-title">
                            <b-icon v-if="!toggleDelete" :icon="icon(event.type)" pack="fad" :class="{ draggy: toggleDrag }" class="icon-fix"></b-icon>
                            <a v-else @click="removeWorkshop(event)">
                                <b-icon icon="minus-circle" pack="fas" type="is-danger"></b-icon>
                            </a>
                            <span>{{event.name}}</span>
                        </p>
                    </header>
                    <div class="card-content">
                        <div class="content">
                            <b-icon icon="calendar-alt" pack="fad"></b-icon>&nbsp;&nbsp;{{$moment(event.date, 'YYYY-MM-DD').format('dddd, D. MMM YY')}}
                            <br>
                            <b-icon icon="clock" pack="fad"></b-icon>&nbsp;&nbsp;{{event.begin}} - {{event.end}}
                        </div>
                    </div>
                    <footer class="card-footer">
                        <a class="card-footer-item" @click="editWorkshop(event)" title="Bearbeiten">
                            <b-icon pack="fad" icon="edit" size="is-small"></b-icon>
                        </a>
                        <a class="card-footer-item" @click="addWorkshop(event)" title="Duplizieren">
                            <b-icon pack="fad" icon="clone" size="is-small"></b-icon>
                        </a>

                    </footer>
                </div>
            </div>

        </Draggable>
    </section>
    <b-modal :active.sync="isCardModalActive" scroll="keep" @close="saveWorkshop()">
        <div class="card is-modal">
            <header class="card-header">
                <p class="card-header-title">
                    <b-icon :icon="icon(editableWorkshop.type)" pack="fad"></b-icon>&nbsp;&nbsp;{{editableWorkshop.name}}
                </p>
            </header>
            <div class="card-content">

                <div class="content">
                    <b-field horizontal label="Name"  class="field-grid">
                        <b-input v-model="editableWorkshop.name"></b-input>
                        <b-select v-model="editableWorkshop.type" placeholder="Bitte wählen Sie den Typ:" :icon="icon(editableWorkshop.type)">
                            <option v-for="type in workshopTypes" :value="type.name">
                                {{type.title}}
                            </option>
                        </b-select>
                    </b-field>
                    <b-field horizontal label="Referent" >
                        <b-input v-model="editableWorkshop.speaker"></b-input>
                    </b-field>
                    <b-field horizontal label="Ort">
                        <b-select v-model="editableWorkshop.location" placeholder="Bitte wählen Sie eine Location" @input="saveEvent()">
                            <option v-for="(location, key) in $root.event.locations" :value="location.id">
                                {{location.name}}
                            </option>
                        </b-select>
                    </b-field>
                    <b-field label="Beschreibung" horizontal>
                        <b-input maxlength="2000" v-model="editableWorkshop.description" type="textarea"></b-input>
                    </b-field>
                    <b-field label="Pflicht" horizontal >
                        <b-switch v-model="editableWorkshop.mandatory">
                        </b-switch>
                    </b-field>
                    <b-field label="Gruppe" horizontal  v-if="editableWorkshop.mandatory !== true">
                        <b-select v-if="!tempGroup.active" v-model="editableWorkshop.group" expanded>
                            <option value="0" key="0">
                                keine Gruppe
                            </option>
                            <option v-for="option in $root.event.groups" :value="option.id" :key="option.id">
                                {{ option.name }}
                            </option>
                        </b-select>
                        <b-input v-else v-model="tempGroup.name" expanded></b-input>
                        <p class="control">
                            <button v-if="tempGroup.active" class="button is-success" @click="newGroup()">
                                <b-icon icon="save" pack="fad"></b-icon>
                            </button>
                            <button v-else class="button is-primary" @click="tempGroup.active = true">
                                <b-icon icon="plus" pack="fal"></b-icon>
                            </button>
                        </p>
                    </b-field>
                    <b-field horizontal label="Datum">
                        <Datepicker :inline="false" v-model="editableWorkshop.date" :min="$root.event.start" :max="$root.event.end" placeholder="Bitte auswählen..." icon="calendar-day" pack="fad">
                        </Datepicker>
                    </b-field>
                    <b-field label="Zeitslot?" horizontal  v-if="editableWorkshop.mandatory !== true">
                        <b-switch v-model="editableWorkshop.timeslotExists">
                        </b-switch>
                    </b-field>
                    <b-field v-if="editableWorkshop.timeslotExists && editableWorkshop.mandatory !== true" label="Beginn/Ende" horizontal >
                        <Timepicker v-if="tempSlot.active" placeholder="Bitte Auswählen..." v-model="tempSlot.begin" :inline="false">
                        </Timepicker>
                        <Timepicker v-if="tempSlot.active" placeholder="Bitte Auswählen..." v-model="tempSlot.end" :inline="false">
                        </Timepicker>
                        <b-select v-if="(typeof $root.event.slots == 'array' || typeof $root.event.slots == 'object') && !tempSlot.active" placeholder="Bitte Auswählen oder neu erstellen" v-model="editableWorkshop.timeslot" expanded @input="updateTime(editableWorkshop.timeslot)">
                            <option v-for="option in $root.event.slots" :value="option.id" :key="option.id">
                                {{ option.name }}
                            </option>
                        </b-select>
                        <p class="control">
                            <button v-if="tempSlot.active" class="button is-success" @click="newSlot()">
                                <b-icon icon="save" pack="fad"></b-icon>
                            </button>
                            <button v-else class="button is-primary" @click="tempSlot.active = true">
                                <b-icon icon="plus" pack="fal"></b-icon>
                            </button>
                        </p>
                    </b-field>
                    <b-field v-else label="Beginn/Ende" horizontal >
                        <Timepicker placeholder="Bitte Auswählen..." v-model="editableWorkshop.begin" :inline="false">
                        </Timepicker>
                        <Timepicker placeholder="Bitte Auswählen..." v-model="editableWorkshop.end" :inline="false">
                        </Timepicker>
                    </b-field>

                    <b-field label="max. Anzahl Teilnehmer" horizontal v-if="editableWorkshop.mandatory !== true">
                        <b-switch v-model="editableWorkshop.quotaExists">
                        </b-switch>
                        <b-numberinput icon-pack="fal" v-if="editableWorkshop.quotaExists" min="0" v-model="editableWorkshop.quota">
                        </b-numberinput>
                    </b-field>
                    <b-button type="is-success" @click="saveWorkshop()">Speichern</b-button>
                </div>
            </div>
        </div>
    </b-modal>
</div>
</template>

<script>
export default {
    name: 'Workshops',
    components: {

    },
    props: {

    },
    data() {
        return {
            toggleDelete: false,
            toggleDrag: true,
            search: '',
            tempSlot: {
                active: false,
                name: '',
                begin: '00:00',
                end: '00:00'
            },
            tempGroup: {
                active: false,
                name: '',
            },
            isCardModalActive: false,
            editableWorkshop: {},
            workshopTypes: [{
                    title: 'Hauptevent',
                    icon: 'calendar-star',
                    name: 'main',
                    default: 'neues Hauptevent'
                },
                {
                    title: 'Vortrag',
                    icon: 'presentation',
                    name: 'presentation',
                    default: 'neues Hauptevent'
                },
                {
                    title: 'Workshop',
                    icon: 'users-class',
                    name: 'workshop',
                    default: 'neues Hauptevent'
                },
                {
                    title: 'Anderes',
                    icon: 'dice-d8',
                    name: 'misc',
                    default: 'neuer Termin'
                }
            ]
        }
    },
    methods: {
        update(id = this.$route.params.id) {
            return true
        },
        saveEvent() {
            this.$root.saveEvent(this.$route.params.id)
        },
        newGroup() {
            let group = {}
            group.id = ++this.$root.event.counter.groups
            group.name = this.tempGroup.name
            if(typeof this.$root.event.groups != 'array' && typeof this.$root.event.groups != 'object') this.$root.event.groups = []
            this.$root.event.groups.push(group)
            if(this.editableWorkshop) {
                this.editableWorkshop.group = group.id
            }
            this.tempGroup.name = ''
            this.tempGroup.active = false
            this.saveEvent()
        },
        addWorkshop(template = {}, init = false) {
            let workshop = {}
            workshop = Object.assign(workshop, template)
            workshop.id = ++this.$root.event.counter.workshops
            if (!workshop.name) {
                workshop.name = 'Neuer Workshop'
            } else if (!init) {
                workshop.name += ' Kopie'
            }
            if (!workshop.type) {
                workshop.type = 'misc'
            }
            this.$root.event.workshops.push(workshop)
            this.saveEvent()
        },
        editWorkshop(workshop) {
            this.isCardModalActive = true
            this.editableWorkshop = workshop

        },
        saveWorkshop() {
            this.isCardModalActive = false
            this.$root.saveEvent(this.$route.params.id, true)
        },
        icon(type = 'misc') {
            let find = this.workshopTypes.find(function (element) {
                return element.name == type
            })
            return find.icon
        },
        removeWorkshop(old) {
            this.$buefy.dialog.confirm({
                title: 'Workshop löschen?',
                message: 'Sind Sie sicher, dass Sie den <br>Workshop <b><i>' + old.name + '</i> löschen</b> möchten?<br>Diese Aktion kann nicht Rückgängig gemacht werden.',
                confirmText: 'Workshop löschen',
                type: 'is-danger',
                hasIcon: true,
                onConfirm: () => {
                    let wksps = []
                    this.$root.event.workshops.forEach(function (element) {
                        if (element.id !== old.id) {
                            wksps.push(element)
                        }
                    });
                    this.$root.event.workshops = wksps
                    this.saveEvent()
                    this.$buefy.toast.open({
                        message: 'Der Workshop <b>' + old.name + '</b> wurde gelöscht',
                        type: 'is-success'
                    })
                }
            })
        },
        newSlot() {
            let slot = {}
            slot.id = ++this.$root.event.counter.slots
            slot.begin = this.tempSlot.begin
            slot.end = this.tempSlot.end
            slot.name = this.tempSlot.begin + ' - ' + this.tempSlot.end
            if(typeof this.$root.event.slots != 'array' && typeof this.$root.event.slots != 'object') this.$root.event.slots = []
            this.$root.event.slots.push(slot)
            if(this.editableWorkshop) {
                this.editableWorkshop.timeslot = slot.id
                this.editableWorkshop.begin = slot.begin
                this.editableWorkshop.end = slot.end
            }
            this.tempSlot.begin = this.tempSlot.end = '00:00'
            this.tempSlot.active = false
            this.saveEvent()
        },
        updateTime(id) {
            let slot
            slot = this.$root.event.slots.find(r => r.id == id)
            if(this.editableWorkshop) {
                this.editableWorkshop.timeslot = slot.id
                this.editableWorkshop.begin = slot.begin
                this.editableWorkshop.end = slot.end
            }
        }
    },
    created() {
        // fetch the data when the view is created and the data is
        // already being observed

        this.update()
    },
    computed: {
        filtered() {
            var origin = this.$root.event.workshops,
                filtered = [],
                patt = new RegExp(this.search, "i");
            this.toggleDrag = true
            if (this.search == '') {
                return origin
            }
            if (this.search.length < 3) {
                return origin
            }
            this.toggleDrag = false
            origin.forEach(entry => {
                if (patt.test(entry.name)) {
                    filtered.push(entry)
                    return
                }
                if (patt.test(entry.description)) {
                    filtered.push(entry)
                    return
                }
                if (patt.test(entry.location)) {
                    filtered.push(entry)
                    return
                }
            })
            return filtered
        }
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.c-preview {
    width: 50px;
}

.hover-rotate-90 .dropdown-trigger .icon i {
    transition: transform .8s ease;
}

.hover-rotate-90.is-active .dropdown-trigger .icon i,
.hover-rotate-90:hover .dropdown-trigger .icon i {
    transform: rotate(90deg);
}

.card.is-grid {
    display: inline-block;
    width: 250px;
    margin: 20px;
    vertical-align: top;
}

.card.is-modal {
    min-width: 270px;
    margin: 20px;
}

.event-list {
    text-align: center;
}

.giggly ,
.giggly>.card{
    transition: transform .05s ease;
    animation-name: giggle;
    animation-duration: .2s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}

@keyframes giggle {
    0% {
        transform: rotate(0deg);
    }

    25% {
        transform: rotate(-1deg);
    }

    50% {
        transform: rotate(0deg);
    }

    75% {
        transform: rotate(1deg);
    }

    1000% {
        transform: rotate(0deg);
    }
}
</style>
